import { render, staticRenderFns } from "./BtnAprovarReprovar.vue?vue&type=template&id=e05ef100"
import script from "./BtnAprovarReprovar.vue?vue&type=script&lang=js"
export * from "./BtnAprovarReprovar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports